import { render, staticRenderFns } from "./IconInstagram.vue?vue&type=template&id=46700e53"
import script from "./IconInstagram.vue?vue&type=script&lang=js"
export * from "./IconInstagram.vue?vue&type=script&lang=js"
import style0 from "./IconInstagram.vue?vue&type=style&index=0&id=46700e53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports